import Front from '@frontapp/plugin-sdk';
import type { WebViewContext } from '@frontapp/plugin-sdk/dist/webViewSdkTypes';
import {
  type ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';

export const FrontContext = createContext<WebViewContext | undefined>(
  undefined,
);

export function useFrontContext() {
  return useContext(FrontContext);
}

export const FrontContextProvider = ({ children }: { children: ReactNode }) => {
  const [context, setContext] = useState<WebViewContext | undefined>();

  useEffect(() => {
    const subscription = Front.contextUpdates.subscribe((frontContext) => {
      setContext(frontContext);
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <FrontContext.Provider value={context}>{children}</FrontContext.Provider>
  );
};
